export * from './FixedAssetsView';
